<template>
  <div style="height: 101%">
  	<van-nav-bar
		  :title="userGroup.group_name"
		  right-text="添加用户"
      left-text="返回"
      left-arrow
      @click-left="$router.push({name: 'peopleList'})"
		  @click-right="onClickRight"
      :fixed="true"
		/>
    <div class="body">
      <van-search placeholder="输入名字搜索" v-model="searchInfo" />
      <van-cell-group>
        <h2 class="block_title">联系人</h2>
        <van-cell-swipe :right-width="65" v-for="user in userListFiltered" :key="user.id">
          <van-cell-group  >
            <van-cell :title="user.alianame||user.name" @click="$router.push({name:'peopleDetail',params:{people_id:user.id}})"/>
          </van-cell-group>
          <span @click="deletePeople(user)" slot="right">删除</span>
        </van-cell-swipe>
      </van-cell-group>
      <van-popup v-model="showModal" position="right" :overlay="false" :lock-scroll="false">
        <van-nav-bar
          title="添加用户"
          left-text="返回"
          left-arrow
          @click-left="showModal=false"
        />
        <van-checkbox-group v-model="result" style="overflow: scroll;height: 87%;">
          <van-cell-group>
            <van-cell v-for="user in userChooseList" :title="user.alianame || user.username" :key="user.user_id">
              <van-checkbox :name="user.user_id" />
            </van-cell>
          </van-cell-group>
        </van-checkbox-group>
        <div style="height: 48px;line-height: 48px; padding-left: 14px;">
          选中{{result.length}}名用户
          <van-button @click="addUser" style="float: right;" size="normal" type="primary">确定</van-button>  
        </div>
      </van-popup>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { Toast,CellSwipe,Dialog  } from 'vant';
import _ from 'lodash'
export default {
  name: 'HelloWorld',
  data () {
    return {
      msg: 'Welcome to Your Vue.js App',
      searchInfo:'',
      showModal:false,
      result:[],
      userListFiltered:[]
    }
  },
  mounted(){
    this.searchChange()
    if(!this.userList){
      this.$store.dispatch('getUserList')
    }
    if(!this.userGroups){
      this.$store.dispatch('getUserByGroups')
    }
  },
  watch:{
    searchInfo(){
      this.searchChange()
    },
    userGroups(){
      this.searchChange()
    },
    '$route'(to,from){
      if (to.name == 'userGroup'){
        this.searchChange()
      }
    }
  },
  beforeRouteLeave(to, from, next){
    this.userListFiltered = []
    next()
  },
  computed:{
  	scHeight:function(){
      return ''+document.documentElement.clientHeight - 138
    },
    ...mapState(['userInfo','userGroups','userList']),
    userGroup(){
      var group_id = this.$route.params.group_id
      for (var i in this.userGroups){
        if (group_id == this.userGroups[i].contact_group_id){
          return this.userGroups[i]
        }
      }
      return {}
    },
    userChooseList(){
      var userChooseList = []
      for(var i in this.userList){
        if(!this.userList[i].contact_group_id){
          userChooseList.push(this.userList[i])
        }
      }
      return userChooseList
    }
  },
  methods:{
    searchChange:_.debounce(function(){
      var regex = new RegExp(this.searchInfo, 'i');
      if (this.userGroup.users){
        console.log('change')
        this.userListFiltered=this.userGroup.users.filter(x=>regex.test(x.alianame)||regex.test(x.name))
      }
    },200),
    getUserByGroups(){
      this.$store.dispatch('getUserByGroups')
    },
  	onClickRight(){
      this.result=[]
      this.showModal = true
  	},
    deletePeople(user){
      var self = this
      Dialog.confirm({
        title: '提示',
        message: '确认移除用户 ' + user.name+' ?' 
      }).then(() => {
        console.log(user)
        self.axios_base.get("session/removeUser?user_id="+user.id).then(function(resp){
        self.$store.dispatch('getUserByGroups')
        self.$store.dispatch('getUserList')
        })
      }).catch(() => {
        // on cancel
      });
    },
    addUser(){
      var self = this
      var user_str = this.result.join(',')
      this.axios_base.get('session/groupAddUser?user_str='+user_str+'&group_id='+this.$route.params.group_id).then(function(resp){
        console.log(resp.data)
        self.$store.dispatch('getUserByGroups')
        self.$store.dispatch('getUserList')
        self.showModal = false
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.block_title{
  margin: 0;
  font-weight: 400;
  font-size: 13px;
  color: rgba(69,90,100,.6);
  padding: 6px 15px 3px;
  background: #e4e4e4;
}
</style>



// WEBPACK FOOTER //
// src/pages/people/groupDetail.vue